module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainlayout"
  }, [_c('div', {
    staticClass: "top-panel"
  }, [_c('div', {
    staticClass: "top-panel-logo-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "top-panel-logo-panel-text"
  }, [_vm._v(_vm._s(_vm.appSettings.appName))]), _vm._v(" "), _c('div', {
    staticClass: "top-panel-logo-panel-cover",
    on: {
      "click": function($event) {
        _vm.logoOnClick()
      }
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "style2": "position:absolute; top:8px; right:12px;"
    }
  }, [_c('top-menu')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('keep-alive', [_c('router-view', {
    staticStyle: {
      "width": "100%",
      "height": "calc(100vh - 50px)",
      "background": "#fff"
    }
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-panel-logo-panel-icon"
  }, [_c('i', {
    staticClass: "fas fa-star"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2fbe4ae","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainLayout.vue
// module id = 368
// module chunks = 0